import React from 'react';
import { Routes, Route } from 'react-router';
import { AssignmentProvider } from '../../context';
import StandardPrinting from './components/StandardPrinting';
import AnswerKey from './components/AnswerKey';
import VocabularyPrinting from './components/VocabularyPrinting';

const MoreActions = () => {
  return (
    <AssignmentProvider>
      <Routes>
        <Route path="/standardPrinting/:isAssessment?" element={<StandardPrinting />} />
        <Route path="/answerKey/:isAssessment?" element={<AnswerKey />} />
        <Route path="/vocabularyPrinting/:activityType?" element={<VocabularyPrinting />} />
      </Routes>
    </AssignmentProvider>
  );
};

export default MoreActions;
